import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { LabeledInfo } from 'ui-components/components/labeled-info';
import { useContextTypes } from 'ui-components/hooks/use-context-types';

import style from './readonly.module.less';
import { emptyObject } from 'ui-components/default-props/empty';
import { CustomsContent } from '../../../../../enums/customs-content';
import { CustomsNonDelivery } from '../../../../../enums/customs-non-delivery';
import { messages } from '../../../components/messages';
import { CustomsContext, useCustomsContext } from '../../../context/context';

export const ReadOnlyCustomsWidgetHeader = () => {
  const intl = useIntl();
  useContextTypes('ReadOnlyCustomsWidgetHeader', CustomsContext, {
    content: PropTypes.string,
    nonDelivery: PropTypes.string,
  });
  const { content, nonDelivery, customsTaxIdentifiers, exemptionCodeOrITN, exportDeclarationNumber, invoiceNumber, importerOfRecord } =
    useCustomsContext();

  const contentTranslation = CustomsContent[content]?.translation || emptyObject;
  const nonDeliveryTranslation = CustomsNonDelivery[nonDelivery]?.translation || emptyObject;

  return (
    <div className={style.header}>
      <LabeledInfo label={intl.formatMessage(messages.contentsLabel)} showMdash={contentTranslation === emptyObject}>
        <FormattedMessage {...contentTranslation} />
      </LabeledInfo>
      <LabeledInfo label={intl.formatMessage(messages.nonDeliveryLabel)} showMdash={nonDeliveryTranslation === emptyObject}>
        <FormattedMessage {...nonDeliveryTranslation} />
      </LabeledInfo>
      <LabeledInfo label={intl.formatMessage(messages.taxIDsLabel)} showMdash={!customsTaxIdentifiers.length}>
        {customsTaxIdentifiers.map(({ type, redactedTaxNumber, taxIdentifierId }) => (
          <div key={taxIdentifierId}>{`${type}: ${redactedTaxNumber}`}</div>
        ))}
      </LabeledInfo>
      <LabeledInfo label={intl.formatMessage(messages.itnOrExemptionLabel)} showMdash={!exemptionCodeOrITN}>
        {exemptionCodeOrITN}
      </LabeledInfo>
      <LabeledInfo label={intl.formatMessage(messages.exportDeclarationNumber)} showMdash={!exportDeclarationNumber}>
        {exportDeclarationNumber}
      </LabeledInfo>
      <LabeledInfo label={intl.formatMessage(messages.invoiceNumber)} showMdash={!invoiceNumber}>
        {invoiceNumber}
      </LabeledInfo>
      <LabeledInfo label={intl.formatMessage(messages.iorLabel)} showMdash={!importerOfRecord}>
        {importerOfRecord?.name}
      </LabeledInfo>
    </div>
  );
};
